import React from 'react';

const Terms = () => {
  return (
    <main className="main-content">
      <div className="tos-page">
        <div className="tos-content">
          <h1>Terms of Service</h1>
          
          <h2>1. Service Agreement</h2>
          <p>By purchasing from Outsourced, you agree to these terms. All sales are final and non-refundable unless we fail to deliver within 48 hours.</p>

          <h2>2. Delivery</h2>
          <p>Server boosts are delivered automatically after payment confirmation. Delivery typically occurs within 30 seconds to 5 minutes. In rare cases, manual processing may take up to 24 hours.</p>

          <h2>3. Warranty</h2>
          <p>Boosts are guaranteed for the duration of the selected plan (1 month or 3 months). If boosts are removed before the warranty period ends, we will replace them at no additional cost.</p>

          <h2>4. User Responsibility</h2>
          <p>Do not kick or ban the boosting accounts from your server. If removed by you or your anti-raid bot, replacement will not be provided. Ensure your server invite link is valid and permanent.</p>

          <h2>5. Payment</h2>
          <p>We accept cryptocurrency payments. Ensure you send the exact amount requested. Network fees should be accounted for separately. Orders expire if payment is not received within the specified time.</p>

          <h2>6. Privacy</h2>
          <p>We collect only the information necessary to process your order: email address and Discord server invite. We do not share your data with third parties.</p>

          <h2>7. Changes to Terms</h2>
          <p>These terms may be updated at any time. Continued use of the service after changes constitutes acceptance of the new terms.</p>

          <h2>8. Contact</h2>
          <p>For support, open a ticket on our Discord server or reach out via Telegram.</p>
        </div>
      </div>
    </main>
  );
};

export default Terms;
